import React from 'react';
import { Row, Col, Typography } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import typo from '../../../constants/dictionaries';
import StatusGP from '../../Table/Status/StatusGP';
import { RowTableDetail, TableDetail } from '../../Common/View/TableViewDetail';
import constant from '../../../constants/constant';
import Table from '../../Table';
import ViewTable from '../../Table/ViewTable';
import Helper from '../../../helper/helper';

const { Text } = Typography;

const ConstructionInfo = ({ congTrinh, loaiCT, banDo, tenCT }) => {
  const {
    tenDVHC,
    diaDiem,
    tenCongTrinh,
    mucDichKTSD,
    luuLuongKT,
    luongNuocKhaiThac,
    luuLuongKhaiThacCTs,
    nguonNuocKTSD,
    cheDoKhaiThac,
    phuongThucKhaiThac,
    thuocSong,
    thuocLVS,
    luuLuongXaDongChayMin,
    luuLuongKhaiThacMax,
    mucNuocDangBinhThuong,
    mucNuocCaoNhatTruocLu,
    luuLuongXaDongChayToiThieu,
    congSuatLapMay,
    luuLuongKhaiThacLonNhat,
    luuLuongLonNhatQuaNMTD,
    mucNuocChet,
    mucNuocDonLu,
    dungTichHuuIch,
    dungTichToanBo,
    hangMucs = [],
    tsHoChuas,
  } = congTrinh || {};

  const tableData =
    luuLuongKhaiThacCTs?.map((item, index) => ({
      ...item,
      stt: index + 1,
    })) || [];

  const luuLuongKhaiThacCTColumns = [
    {
      title: '#',
      dataIndex: 'stt',
      align: 'center',
      width: '6%',
    },
    {
      title: 'Lưu lượng khai thác',
      dataIndex: 'giaTriLuuLuongKhaiThac',
      width: '20%',
    },
    {
      title: 'Đơn vị đo',
      dataIndex: 'donViDoLuuLuongKhaiThac',
      width: '10%',
    },
    {
      title: 'Giai đoạn',
      dataIndex: 'giaiDoanLuuLuongKhaiThac',
      width: '15%',
    },
    {
      title: 'Từ',
      dataIndex: 'giaiDoanLuuLuongKhaiThacFrom',
      width: '15%',
      render: (value, row) =>
        Helper.formatTableDate(row.giaiDoanLuuLuongKhaiThacFrom),
    },
    {
      title: 'Đến',
      dataIndex: 'giaiDoanLuuLuongKhaiThacTo',
      width: '15%',
      render: (value, row) =>
        Helper.formatTableDate(row.giaiDoanLuuLuongKhaiThacTo),
    },
    {
      title: 'Ghi chú',
      dataIndex: 'ghiChuLuuLuongKhaiThac',
      width: '20px',
    },
  ];

  return (
    <Row gutter={50}>
      <Col>
        <Row style={{ marginBottom: 15 }}>
          <TableDetail>
            {banDo && (
              <RowTableDetail title={typo.cscore_tnn_tinh_trang}>
                <StatusGP trangthai={banDo} />
              </RowTableDetail>
            )}
            {banDo && (
              <RowTableDetail title={typo.cscore_tnn_groupUnit}>
                {tenCT}
              </RowTableDetail>
            )}
            <RowTableDetail title={typo.cscore_tnn_license_construction}>
              {tenCongTrinh}
            </RowTableDetail>
            <RowTableDetail title={typo.cscore_tnn_license_mining_location}>
              {diaDiem}
            </RowTableDetail>
            <RowTableDetail title={typo.cscore_tnn_license_purpose}>
              {mucDichKTSD}
            </RowTableDetail>
            {/*<RowTableDetail title={typo.cscore_tnn_luuLuongKhaiThac}>{luuLuongKT}</RowTableDetail>*/}
            {/* <RowTableDetail title={typo.cscore_tnn_luongNuocKhaiThac}>
              {luongNuocKhaiThac}
            </RowTableDetail> */}
            <RowTableDetail title={typo.cscore_tnn_license_mining_mode}>
              {cheDoKhaiThac}
            </RowTableDetail>
            <RowTableDetail title={typo.cscore_tnn_license_mining_method}>
              {phuongThucKhaiThac}
            </RowTableDetail>
            <RowTableDetail title={typo.cscore_tnn_license_resource}>
              {nguonNuocKTSD}
            </RowTableDetail>
            <RowTableDetail title={typo.cscore_tnn_thuocSong}>
              {thuocSong}
            </RowTableDetail>
            <RowTableDetail title={typo.cscore_tnn_thuocLVS}>
              {thuocLVS}
            </RowTableDetail>
            {loaiCT === constant.DICT_LOAI_CT.NM_HOCHUA && (
              <>
                <RowTableDetail
                  title={typo.cscore_tnn_luuLuongXaDongChayToiThieu}
                >
                  {luuLuongXaDongChayMin}
                </RowTableDetail>
                <RowTableDetail title={typo.cscore_tnn_luuLuongKhaiThacLonNhat}>
                  {luuLuongKhaiThacMax}
                </RowTableDetail>
                <RowTableDetail title={typo.cscore_tnn_dungTichHuuIch}>
                  {dungTichHuuIch}
                </RowTableDetail>
                <RowTableDetail title={typo.cscore_tnn_dungTichToanBo}>
                  {dungTichToanBo}
                </RowTableDetail>
              </>
            )}

            {loaiCT === constant.DICT_LOAI_CT.NM_THUYDIEN && (
              <>
                <RowTableDetail title={typo.cscore_tnn_congSuatLapMay}>
                  {congSuatLapMay}
                </RowTableDetail>
                <RowTableDetail title={typo.cscore_tnn_luuLuongMaxQuaNMTD}>
                  {luuLuongLonNhatQuaNMTD}
                </RowTableDetail>
                <RowTableDetail
                  title={typo.cscore_tnn_luuLuongXaDongChayToiThieu}
                >
                  {luuLuongXaDongChayToiThieu}
                </RowTableDetail>
                <RowTableDetail title={typo.cscore_tnn_dungTichHuuIch}>
                  {dungTichHuuIch}
                </RowTableDetail>
                <RowTableDetail title={typo.cscore_tnn_dungTichToanBo}>
                  {dungTichToanBo}
                </RowTableDetail>
              </>
            )}

            {(loaiCT === constant.DICT_LOAI_CT.NM_THUYDIEN ||
              loaiCT === constant.DICT_LOAI_CT.NM_HOCHUA) && (
              <>
                <RowTableDetail title={typo.cscore_tnn_mucNuocChet}>
                  {mucNuocChet}
                </RowTableDetail>
                <RowTableDetail title={typo.cscore_tnn_mucNuocDonLu}>
                  {mucNuocDonLu}
                </RowTableDetail>
                <RowTableDetail title={typo.cscore_tnn_mucNuocDangBinhThuong}>
                  {mucNuocDangBinhThuong}
                </RowTableDetail>
                <RowTableDetail title={typo.cscore_tnn_mucNuocCaoNhatTruocLu}>
                  {mucNuocCaoNhatTruocLu}
                </RowTableDetail>
              </>
            )}
          </TableDetail>

          <Row style={{ marginTop: 20 }} />
          <Typography.Text style={{ marginLeft: 20, color: '#096dd9' }}>
            Lưu lượng khai thác
          </Typography.Text>
          <ViewTable
            columns={luuLuongKhaiThacCTColumns}
            dataSource={tableData}
            pagination={{ hideOnSinglePage: true }}
          />
        </Row>
      </Col>
    </Row>
  );
};

ConstructionInfo.propTypes = {
  congTrinh: PropTypes.any.isRequired,
  loaiCT: PropTypes.number.isRequired,
};

export default connect()(ConstructionInfo);
